import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Row, Col, Select, FormInstance, Table, Button, Spin, Space } from "antd";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, PlusSquareFilled, StopOutlined } from '@ant-design/icons';
import { AlignType } from 'rc-table/lib/interface';

import PessoaFisicaEnderecoExibe from "./PessoaFisicaEnderecoExibe";
import { IEnderecoPessoaFisica, IDadosReceitaCpf } from "./InterfacePessoaFisica";
import { errorMessage, infoMessage, mostrarInfo } from "../../../utils/messages";
import { IEstado, IPais } from "../../../Interfaces/Localidades";
import { maskCep } from "../../../utils/maskFunctions";
import { onlyNumbers } from "../../../utils/utilsFunctions";
import { consultarCep, obterMunicipios } from "../../../services/apiExternos";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";


const { Option } = Select;

interface IProps {
  form: FormInstance<any>;
  paises: IPais[];
  estados: IEstado[];
  enderecos: IEnderecoPessoaFisica[];
  setEnderecos: React.Dispatch<React.SetStateAction<IEnderecoPessoaFisica[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 :  Histórico;
  dadosReceitaCpf: IDadosReceitaCpf;
  setDadosReceitaCpf: React.Dispatch<React.SetStateAction<IDadosReceitaCpf>>;
}

const PessoaFisicaEndereco = ({ form, enderecos, paises, estados, setEnderecos, manter, dadosReceitaCpf, setDadosReceitaCpf }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo edição
  const [exibirModalEnd, setExibirModalEnd] = useState(false);
  const [exibirEndCadastrado, setExibirEndCadastrado] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");

  const [cidades, setCidades] = useState<any>([]);
  //  const [cidades, setCidades] =  useState([]);
  const [isUfDisabled, setIsUfDisabled] = useState(true);
  const [isCidadeDisabled, setIsCidadeDisabled] = useState(true);


  useEffect(() => {
    if (enderecos && enderecos.length === 0) {
      setExibirEndCadastrado("none")
    } else {
      setExibirEndCadastrado("inline")
      setValoresAuxiliares();
    }
  }, [enderecos]);

  const setValoresAuxiliares = (() => {
    enderecos.forEach(endereco => {
      tipoEndereco.forEach(e => {
        if (endereco.csTpEndereco === e.enum) {
          endereco.tipoEndereco = e.tipoEndereco
        }
      })
    })
  })

  function setTpEndereco(csTpEndereco: number) {
    let tipoEnderecoReturn = "";
    tipoEndereco.forEach((e: any) => {
      if (csTpEndereco === e.enum) {
        tipoEnderecoReturn = e.tipoEndereco
      }
    })
    return tipoEnderecoReturn;
  }

  useEffect(() => {
    if (manter === 2 || manter === 9) { // Consultar / Histórico
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);

  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // PASSA O MODAL PARA O MODO EDIÇÃO
    }
  }, [estadoModal])


  const controleDaGrid = (botao: string) => {
    if (form.getFieldValue("nuCpf") === "") {
      mostrarInfo("Não é possível incluir novo endereço", "CPF ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalEnd(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalEnd(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalEnd(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    }

  };

  const validarEnd = () => {
    let erroEncontrado = false;
    if (form.getFieldValue("idPais") === undefined) {
      errorMessage("O campo país é obrigatório.");
      erroEncontrado = true;
    } else if (form.getFieldValue("idEstado") === undefined && form.getFieldValue("idPais") === 1) {
      errorMessage("O campo UF é obrigatório.");
      erroEncontrado = true;
    } else if (form.getFieldValue("csTpEndereco") === undefined) {
      errorMessage("O campo tipo de endereço é obrigatório.");
      erroEncontrado = true;
    } else if (form.getFieldValue("idCidade") === undefined) {
      // SE O CAMPO nmCidade estiver preenchido, tenta localizar o idCidade no DATASET cidades. Isto ocorre quando a informação do nmCidade vem do CEP.
      if ((form.getFieldValue("nmCidade") !== undefined) && (form.getFieldValue("nmCidade") !== "")) {
        cidades?.forEach((e: any) => {
          if (e?.nome?.toUpperCase() === form.getFieldValue("nmCidade").toUpperCase()) {
            form.setFieldsValue({
              idCidade: e.id,
            });
          }
        })

      }
      // TESTA NOVAMENTE O CAMPO idCidade
      if (form.getFieldValue("idCidade") === undefined) {
        errorMessage("O campo Munícipio é obrigatório.");
        erroEncontrado = true;
      }
    }

    if (!erroEncontrado) {
      form
        .validateFields([
          "id",
          "csTpEndereco",
          "nuCep",
          "teEndereco",
          "nuEndereco",
          "teComplemento",
          "nmBairro",
          "nmCidade",
        ])
        .then(() => {
          controleDaGrid("incluir");
          setDadosEnderecos();
          // successMessage(estadoModal === 3 ? "Endereço Alterado" : "Endereço Adicionado");

        })
        .catch((error) => {
          errorMessage("Campo obrigatório não preechido");
        });
    }
  };


  function setDadosEnderecos() {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setEnderecos(pre => {
        return pre.map(end => {
          if (end.emEdicao) {
            return ({
              idPessoaFisicaEndereco: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaEndereco")) : -1,
              csTpEndereco: Number(form?.getFieldValue("csTpEndereco")),
              nuCep: onlyNumbers(form?.getFieldValue("nuCep")),
              teEndereco: form?.getFieldValue("teEndereco").toUpperCase(),
              nuEndereco: form?.getFieldValue("nuEndereco") ? form?.getFieldValue("nuEndereco") : undefined,
              teComplemento: form?.getFieldValue("teComplemento") ? form?.getFieldValue("teComplemento").toUpperCase() : undefined,
              nmBairro: form?.getFieldValue("nmBairro") ? form?.getFieldValue("nmBairro").toUpperCase() : undefined,
              idCidade: form?.getFieldValue("idCidade") ? Number(form?.getFieldValue("idCidade")) : undefined,
              idPais: form?.getFieldValue("idPais") ? Number(form?.getFieldValue("idPais")) : undefined,
              idEstado: form?.getFieldValue("idEstado") ? Number(form?.getFieldValue("idEstado")) : undefined,
              nmCidade: form?.getFieldValue("nmCidade") ? form?.getFieldValue("nmCidade").toUpperCase() : null,
              nmPais: form?.getFieldValue("nmPais") ? form?.getFieldValue("nmPais").toUpperCase() : null,
              nmEstado: form?.getFieldValue("nmEstado") ? form?.getFieldValue("nmEstado").toUpperCase() : null,
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return end
          }
        })
      });
    } else {
      setEnderecos([
        ...enderecos,
        {
          idPessoaFisicaEndereco: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaEndereco")) : -1,
          csTpEndereco: Number(form?.getFieldValue("csTpEndereco")),
          tipoEndereco: setTpEndereco(Number(form?.getFieldValue("csTpEndereco"))),
          nuCep: onlyNumbers(form?.getFieldValue("nuCep")),
          teEndereco: form?.getFieldValue("teEndereco").toUpperCase(),
          nuEndereco: form?.getFieldValue("nuEndereco") ? form?.getFieldValue("nuEndereco") : undefined,
          teComplemento: form?.getFieldValue("teComplemento") ? form?.getFieldValue("teComplemento").toUpperCase() : undefined,
          nmBairro: form?.getFieldValue("nmBairro") ? form?.getFieldValue("nmBairro").toUpperCase() : undefined,
          idCidade: form?.getFieldValue("idCidade") ? Number(form?.getFieldValue("idCidade")) : undefined,
          idPais: form?.getFieldValue("idPais") ? Number(form?.getFieldValue("idPais")) : undefined,
          idEstado: form?.getFieldValue("idEstado") ? Number(form?.getFieldValue("idEstado")) : undefined,
          nmCidade: form?.getFieldValue("nmCidade") ? form?.getFieldValue("nmCidade").toUpperCase() : null,
          nmPais: form?.getFieldValue("nmPais") ? form?.getFieldValue("nmPais").toUpperCase() : null,
          nmEstado: form?.getFieldValue("nmEstado") ? form?.getFieldValue("nmEstado").toUpperCase() : null,
          statusReg: 1,
          emEdicao: false,
          touched: true,
        },
      ]);
    }
    form.resetFields([
      "id",
      "csTpEndereco",
      "tipoEndereco",
      "nuCep",
      "teEndereco",
      "nuEndereco",
      "teComplemento",
      "nmBairro",
      "nmPais",
      "nmEstado",
      "nmCidade",
      "idCidade",
      "idEstado",
      "idPais",
    ]);
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  async function getCEP(cep: string) {
    // props.setLoadding(true);
    if (cep) {
      setTipLoading("Buscando dados do CEP ...");
      setLoading(true);
      await consultarCep(onlyNumbers(cep)).then((response) => {
          setLoading(false);
          if (!response.data) {
            errorMessage(
              "Não foi possível coletar informações sobre o CEP informado. Verifique se o CEP está correto."
            );
          } else {
            form.setFieldsValue({
              teEndereco: response.data?.endereco ? response.data?.endereco.toUpperCase() : undefined,
              teComplemento: response.data?.complemento ? response.data?.complemento.toUpperCase() : undefined,
              nmBairro: response.data?.bairro ? response.data?.bairro.toUpperCase() : undefined,

              nmCidade: response.data?.cidade ? response.data?.cidade.toUpperCase() : undefined,
              nmEstado: response.data?.uf ? response.data?.uf.toUpperCase() : undefined,

            });
            setEstadoCidade(response.data?.uf ? response.data?.uf.toUpperCase() : '', response.data?.cidade ? response.data?.cidade.toUpperCase() : '')
          }
        })
        .catch((error) => {
          setLoading(false);
          mostrarInfo("Erro de acesso à API de CEP", "Não foi possível acessar a API de busca/validação do CEP. Tente novamente mais tarde, por favor. Se o erro persisiter, entre em contato com o suporte.");
        })
    }
  }

  const [dadoBrasilia] = useState({
    id: 5300108,
    nome: "Brasilia",
    ibge: 5300108,
    idPais: 76,
    nmPais: "Brasil",
  });

  // Retorna todas as cidadas de um estado pelo id
  const getCidades = async (value: string) => {
    // Quando encontrado o ID de DF, seleciona apenas Brasilia como única cidade
    // se não, retona todos disponníveis no banco
    if (value === 'DF') {
      let arrays = [dadoBrasilia];
      setCidades(arrays);

      form.setFieldsValue({
        idCidade: dadoBrasilia.id,
        nmCidade: dadoBrasilia.nome,
      });
    } else {
      setTipLoading("Buscando dados das cidades do estado ...");
      setLoading(true);
      await obterMunicipios(value).then((response) => {
        setCidades(response?.data);
        setLoading(false);
        setIsCidadeDisabled(false)
      })
        .catch((error) => {
          setLoading(false);
          mostrarInfo("Erro de acesso à API de Estados e Municípios", "Não foi possível localizar as cidades do Estado. Por favor, complemente as informações de UF e Município manualmente");
        });
    }
  };

  // Tenta localizar idEstado e idCidade Cidade recebidas da consulta do CEP ou dos dados da RECEITA CPF.
  const setEstadoCidade = async (uf: string, cidade: string) => {
    // Percorre o dataset de estados e tenta localizar o ID pela UF
    let idUf = 0
    estados.forEach(e => {
      if (e.nome === uf) {
        idUf = e.id
      }
    })

    form.setFieldsValue({
      idEstado: idUf,
    });

    if (uf === 'DF') { // UF = DF
      form.setFieldsValue({
        idCidade: dadoBrasilia.id,
      });
    } else {
      setTipLoading("Buscando dados das cidades do estado ...");
      setLoading(true);
      await obterMunicipios(uf).then((response) => {
        setCidades(response?.data);
        setLoading(false);
        setIsCidadeDisabled(false)
      }).catch((error) => {
        setLoading(false);
        mostrarInfo("Erro de acesso à API de Estados e Municípios", "Tente novamente mais tarde. Se o erro persistir, entre em contato com o suporte.");
      });;
    }
  };


  const handlerCidade = async (index: any) => {
    form.setFieldsValue({
      nmCidade: index.children,
      idCidade: Number(index.key)
    })
  };

  const handlerEstado = async (index: any) => {
    form.setFieldsValue({
      nmEstado: index.children,
      idEstado: Number(index.key),
      nmCidade: undefined,
      idCidade: undefined,
    });
    // getCidades(Number(index.key));
    getCidades(index.children);
  };

  const handlerPais = async (index: any) => {
    form.setFieldsValue({
      nmPais: index.children,
      idPais: Number(index.key),
      nmEstado: undefined,
      idEstado: undefined,
      nmCidade: undefined,
      idCidade: undefined,
    });
    if (form?.getFieldValue("idPais") === 1) {
      setIsUfDisabled(false)
    } else {
      setIsUfDisabled(true)
      setIsCidadeDisabled(true)
    }
  };

  const handlerTpEndereco = async (value: any) => {
    form.setFieldsValue({
      tpEndereco: value.children,
      csTpEndereco: value.key,
    })
  };

  const maskCepChange = (isValue: any) => {
    isValue = maskCep(isValue);
    form.setFieldsValue({
      nuCep: isValue,
    })
  };

  const setEnderecoComDadosReceita = (() => {
    if (manter === 1) { // Insrir
      // Verifica se existe dados de endereço recebidos da receita federal referente ao CPF. Usamos o CEP, poi o CPF é o valor default para o dataset.
      if (dadosReceitaCpf?.cep) {
        // Se existir, faz um preenchimento prévio dos campos.
        form.setFieldsValue({
          "nuCep": maskCep(dadosReceitaCpf?.cep),
          "teEndereco": dadosReceitaCpf?.tipoLogradouro + " " + dadosReceitaCpf?.logradouro,
          "nuEndereco": dadosReceitaCpf?.numeroLogradouro,
          "teComplemento": dadosReceitaCpf?.complemento,
          "nmBairro": dadosReceitaCpf?.bairro,
          "nmCidade": dadosReceitaCpf?.municipio,
          "nmEstado": dadosReceitaCpf?.uf,
          "idEstado": estados.find(estado => estado.sigla === dadosReceitaCpf?.uf)?.id,

          "nmPais": dadoBrasilia.nmPais,
          "idPais": dadoBrasilia.idPais,
        });
        setEstadoCidade(dadosReceitaCpf?.uf ? dadosReceitaCpf?.uf.toUpperCase() : "", dadosReceitaCpf?.municipio ? dadosReceitaCpf?.municipio : "");
      }
    }
  });



  const columns = [
    {
      key: "1",
      width: "90%",
      title: "Endereço: ",
      dataIndex: "",
      render: (IEnd: IEnderecoPessoaFisica) =>
        <div>
          <p style={{ margin: 0 }}>({IEnd.tipoEndereco}) - {IEnd.teEndereco}, {IEnd.nuEndereco && IEnd.nuEndereco !== "" ? IEnd.nuEndereco : "SEM Nº"} - {IEnd.nmCidade?.toUpperCase()}/{IEnd.nmEstado} - {maskCep(IEnd.nuCep)}</p>,
        </div>,
    },
    {
      key: "2",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IEndereco: IEnderecoPessoaFisica) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 9 ? "none" : (manter === 2 && IEndereco.statusReg !== 1 ? "inline" : "none") }}>
              <StopOutlined
                title="Item inativo"
                style={{ color: "red", marginLeft: 12 }}
              />
            </div>

            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  if (IEndereco.idPais === 1) {
                    setIsUfDisabled(false)
                  } else {
                    setIsUfDisabled(true)
                    setIsCidadeDisabled(true)
                  }

                  form.setFieldsValue({
                    "idPessoaFisicaEndereco": IEndereco.idPessoaFisicaEndereco,

                    "csTpEndereco": IEndereco.csTpEndereco,
                    "tipoEndereco": IEndereco.tipoEndereco,

                    "nuCep": IEndereco.nuCep,
                    "teEndereco": IEndereco.teEndereco,
                    "nuEndereco": IEndereco.nuEndereco,
                    "teComplemento": IEndereco.teComplemento,
                    "nmBairro": IEndereco.nmBairro,

                    "idCidade": IEndereco.idCidade,
                    "nmCidade": IEndereco.nmCidade,

                    "idPais": IEndereco.idPais,
                    "nmPais": IEndereco.nmPais,

                    "idEstado": IEndereco.idEstado,
                    "nmEstado": estados.find(estado => estado.id === IEndereco.idEstado)?.sigla, //chamaram a chave de nmEstado em vez de siglaEstado

                  });
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  enderecos.forEach(end => {
                    if (end === IEndereco) {
                      end.statusReg = 1;
                      end.touched = true;
                      end.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      end.emEdicao = false;
                    }
                  })
                  IEndereco.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir"
                style={{ color: "red", display: (IEndereco?.idPessoaFisicaEndereco && IEndereco?.idPessoaFisicaEndereco < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setEnderecos(enderecos.filter((endereco) => endereco !== IEndereco));
                }}
              />
            </div>

            <div style={{ display: (IEndereco?.idPessoaFisicaEndereco && IEndereco?.idPessoaFisicaEndereco > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (IEndereco?.statusReg === 1 || IEndereco?.statusReg === undefined) ? "none" : "inline" }}
                  onClick={() => {
                    IEndereco.touched = true; // MARCA O REGISTRO ALTERADO.
                    IEndereco.statusReg = (IEndereco.statusReg === 1 ? 2 : 1);
                    setEnderecos(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(end => {
                        if (end.idPessoaFisicaEndereco === IEndereco.idPessoaFisicaEndereco) {
                          return IEndereco;
                        } else {
                          return end;
                        }
                      });
                    });
                  }}
                />
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (IEndereco?.statusReg === 1 || IEndereco?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    IEndereco.touched = true; // MARCA O REGISTRO ALTERADO.
                    IEndereco.statusReg = (IEndereco.statusReg === 1 ? 2 : 1);
                    setEnderecos(pre => {
                      return pre.map(end => {
                        if (end.idPessoaFisicaEndereco === IEndereco.idPessoaFisicaEndereco) {
                          return IEndereco;
                        } else {
                          return end;
                        }
                      });
                    });
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },
  ];


  let tipoEndereco = [
    { enum: 1, tipoEndereco: "PESSOAL" },
    { enum: 2, tipoEndereco: "COMERCIAL" },
  ];

  return (
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirEndereco"
        type="primary"
        shape="round"
        onClick={() => {
          form.setFieldsValue({
            nmPais: "Brasil",
            idPais: 1,
          });
          setIsUfDisabled(false)

          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          if (enderecos && enderecos.length >= 2) {
            infoMessage("O limite de endereços cadastrados é 2.")
          } else {
            setEnderecoComDadosReceita();
            controleDaGrid("incluirEndereco");
          }
        }}
        icon={<PlusOutlined />}
      >
        Incluir Endereço
      </Button>

      <Modal title="Endereço" open={exibirModalEnd}
        style={{ top: 20 }}
        destroyOnHidden={true}
        width={750}
        onCancel={() => {
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("cancelar");
          form.resetFields([
            "id",
            "csTpEndereco",
            "tipoEndereco",
            "nuCep",
            "teEndereco",
            "nuEndereco",
            "teComplemento",
            "nmBairro",
            "nmPais",
            "nmEstado",
            "nmCidade",
            "idCidade",
            "idEstado",
            "idPais",
          ]);
        }}
        closable={false}
        cancelText="Cancelar"
        cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}

        onOk={() => {
          validarEnd();
          setDadosReceitaCpf({}); // LIMPA OS DADOS DA RECEITA, CASO EXISTAM. ISTO EVITARÁ QUE O SEGUNDO ENDEREÇO SEJA PREENCHIDO AUTOMATICAMENTE COM O ENDEREÇO QUE RETORNOU DA RECEITA.
        }}
        okText={estadoModal === 3 ? "Alterar" : "Incluir"}
        okButtonProps={{ shape: "round", icon: <CheckOutlined /> }}
      >

        <Spin spinning={loading} tip={tipLoading}>
          <Row>
            <Col xs={24} sm={8}>
              <Form.Item label='Tipo Endereço'
                labelCol={{ span: 12 }}
                wrapperCol={{ span: 24 }}
                name="tipoEndereco"
                rules={[
                  {
                    required: true,
                    message: "Campo Tipo de endereço obrigatório não preechido",
                  },
                ]}

              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Selecionar...'
                  onChange={(_, index) => {
                    handlerTpEndereco(index);
                  }}
                >
                  {tipoEndereco?.map((e: any) => (
                    <Option key={e.enum} value={e.enum}
                    >
                      {e.tipoEndereco}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label='CEP'
                name="nuCep"
                rules={[
                  {
                    required: true,
                    message: "Campo CEP obrigatório não preechido",
                  },
                ]}
              >
                <Input
                  placeholder='CEP'
                  onChange={(e) => maskCepChange(e.target.value)}
                  onBlur={(e) => getCEP(e.target.value)}
                  maxLength={10} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={18}>
              <Form.Item label='Endereço'
                labelCol={{ span: 16 }}
                labelAlign="left"
                name="teEndereco"
                rules={[
                  {
                    required: true,
                    message: "Campo Endereço obrigatório não preechido",
                  },
                ]}
              >
                <Input
                  placeholder='Endereço'
                  maxLength={100} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={6}>
              <Form.Item label='Número'
                name="nuEndereco"
              >
                <Input
                  placeholder='Número'
                  // onChange={(e) => {
                  //   maskNumero(e.target.value);
                  // }}
                  maxLength={10} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} sm={16}>
              <Form.Item label='Complemento'
                labelCol={{ span: 16 }}
                labelAlign="left"
                name={"teComplemento"}
              >
                <Input
                  placeholder='Complemento'
                  maxLength={100} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label='Bairro'
                name={"nmBairro"}
              >
                <Input
                  placeholder='Bairro'
                  maxLength={100} />
              </Form.Item>
            </Col>
          </Row>

          <Row>

            <Col xs={24} sm={8}>
              <Form.Item label='País'
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 24 }}
                labelAlign="left"
                colon={false}
                name="nmPais"
              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='País'
                  // defaultValue="Brasil"
                  onChange={(_, index) => {
                    handlerPais(index);
                  }}
                >
                  {paises?.map((e: IPais) => (
                    <Option key={e.idM49} value={e.idM49}
                    >
                      {e.nome}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label='UF'
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 24 }}
                labelAlign="left"
                colon={false}
                name="nmEstado"
              >
                <Select
                  disabled={isUfDisabled}
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='UF'
                  onChange={(_, index) => {
                    handlerEstado(index);
                  }}
                >
                  {estados?.map((e: IEstado) => (
                    <Option key={e.id} value={e.id}
                    >
                      {e.sigla}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label='Município'
                name="nmCidade"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Campo Município obrigatório não preechido",
                  },
                ]}
              >
                <Select
                  disabled={isCidadeDisabled}
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Município'
                  onChange={(_, index) => {
                    handlerCidade(index);
                  }}
                >
                  {cidades?.map((e: any) => (
                    <Option key={e.id} value={e.id}
                    >
                      {e.nome}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>

      <Row style={{ display: exibirEndCadastrado }}>
        <Col
          xs={24}
          sm={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small"
            columns={columns}
            rowKey={(record) => record.idPessoaFisicaEndereco ? record.idPessoaFisicaEndereco : 0}
            expandable={{
              expandedRowRender: (record) =>
                <div style={{ backgroundColor: record.statusReg === 1 ? (record.touched ? "blue" : "") : (record.touched ? "blue" : "red") }}>
                  <PessoaFisicaEnderecoExibe
                    endereco={record}
                  />
                </div>,
              rowExpandable: () => true,
            }}

            dataSource={enderecos}
            pagination={false} />
        </Col>
      </Row>

    </>

  );
};

export default PessoaFisicaEndereco;